<template>
  <div>
    <pre>{{ deployment }}</pre>
  </div>
</template>

<script>
import { get, success_message, error_message } from "@/utils";

export default {
  name: "NgineManagerDeploymentManager",
  components: {},
  data() {
    return {
      deployment: {},
    };
  },
  computed: {},
  methods: {
    load_deployment(deployment) {
      let v = this;
      get("/ngine/deployment", {
        uuid: deployment.uuid,
      })
        .then((response) => {
          v.deployment = response;
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
